import { Helper } from '../../Helper';
export class SetObjectDataPropertyHelperBase extends Helper {
    emit(sb, node, options) {
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, sb.pushValueOptions(options), this.getObject(sb));
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitPushInt(node, 1);
        sb.emitOp(node, 'PACK');
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=SetObjectDataPropertyHelperBase.js.map
